import React from "react";

export default function OrderCancellationTable({ data }) {
  const table = {
    header: [
      {
        id: 1,
        title: (
          <span>
            주문취소
            <br />
            (미입금)
          </span>
        ),
      },
      {
        id: 2,
        title: (
          <span>
            결제완료 <br />
            (신용카드)
          </span>
        ),
      },
      {
        id: 3,
        title: (
          <span>
            주문취소
            <br />
            (무통장입금)
          </span>
        ),
      },
    ],
  };
  return (
    <>
      <div className="p-2 bg-primary-blue text-white font-bold">
        주문 취소 정보
      </div>
      <div className="w-full block whitespace-nowrap overflow-auto">
        <table className="w-full text-center text-black">
          <thead>
            <tr className="border border-[#dddddd]" key={0}>
              {table.header.map((val) => (
                <th
                  className="p-2 bg-[#f2f2f4] border border-[#dddddd]"
                  key={val.id}
                >
                  {val.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="p-3 border border-[#dddddd]">
                {data?.unpaid?.cases}건
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.creditCard?.cases}건
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.deposit?.cases}건
              </td>
            </tr>
            <tr>
              <td className="p-3 border border-[#dddddd]">
                {data?.unpaid?.amount}원
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.creditCard?.amount}원
              </td>
              <td className="p-3 border border-[#dddddd]">
                {data?.deposit?.amount}원
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
